import { Action, PageState } from "../../components/TypeDefinitions";

export function unlinkSubForm<
  E extends Extract<
    Action,
    {
      type: "unlinkSubForm";
    }
  >
>(action: E, draft: PageState): void {
  const { subFormId, parentFormId } = action.payload;

  draft.data.inspectionTypeTemplate.configuration.forms.every((form) => {
    if (form.id === parentFormId) {
      let subformIndex = form.subformIds.findIndex((id) => id === subFormId);
      if (subformIndex === -1) return false;
      form.subformIds.splice(subformIndex, 1);
      return false;
    }
    return true;
  });
}
